export class Menu {

  constructor(fields) {
    this.fields = fields;
  }

  mapToStandard() {

    const hasCMSPage = !!this.fields.attributes.route?.parameters?.node;

    return {
      id: this.fields.attributes?.id,
      label: this.fields.attributes?.title,
      url: this.fields.attributes?.url,
      hasCMSPage: hasCMSPage,
      component: !hasCMSPage
        ? this.fields.attributes?.title?.replace(/[^a-zA-Z]/gi, '')
        : null,
      description: this.fields.attributes?.description
    };
  }
}
